"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundSalary = roundSalary;
function roundSalary(highestSalary) {
    const maximumBySalaryRate = Math.ceil(highestSalary);
    // always round to higher ten value, so slider has acceptable value (and greater then BE highest value) in max range
    const maxRoundedToTen = 10 - (maximumBySalaryRate % 10) + maximumBySalaryRate;
    return maxRoundedToTen;
}
